import { REFERRAL_RESET, REFERRAL_SET_CODE, REFERRAL_SET_TARGET_SEGMENT, REFERRAL_SET_URL } from '../action-types';

const reset = () => ({ type: REFERRAL_RESET });
// @ts-expect-error - Automatic, Please fix when editing this file
const setCode = (code) => ({ code, type: REFERRAL_SET_CODE });
// @ts-expect-error - Automatic, Please fix when editing this file
const setTargetSegment = (targetSegment) => ({ targetSegment, type: REFERRAL_SET_TARGET_SEGMENT });
// @ts-expect-error - Automatic, Please fix when editing this file
const setUrl = (url) => ({ type: REFERRAL_SET_URL, url });

export default { reset, setCode, setTargetSegment, setUrl };
